import { getSlot } from "@/mds/utils/slots";
import { SidebarSectionItemSlotName } from "@/components/layout/components/sidebar/sidebar-section/sidebar-section.types";
import { MDSText, MDSTextOverflow, MDSTextVariant } from "@/mds/components/text";
import { HTMLAttributes, ReactNode } from "react";
import {
  StyledSectionItemContainer,
  StyledSectionItemContainerLeft,
  StyledSectionItemContainerRight,
} from "@/components/layout/components/sidebar/sidebar-section/sidebar-section.styles";
import { MDSIcon, MDSIconKind } from "@/mds/components/icon";

interface SidebarSectionItemProps extends HTMLAttributes<HTMLDivElement> {
  iconKind: MDSIconKind | ReactNode;
  label: string;
  children?: ReactNode;
  isDisabled?: boolean;
  indent?: boolean;
  hasUnreadUpdate?: boolean;
}

export const SidebarSectionItem = ({
  iconKind,
  label,
  indent,
  hasUnreadUpdate,
  ...props
}: SidebarSectionItemProps) => {
  const rightButtons = getSlot(props.children, SidebarSectionItemSlotName.ButtonsRight);

  return (
    <StyledSectionItemContainer
      data-component="SidebarSectionItem"
      $hasUnreadUpdate={hasUnreadUpdate}
      $indent={indent}
      {...props}
    >
      <StyledSectionItemContainerLeft>
        {typeof iconKind === "string" ? (
          <MDSIcon kind={iconKind as MDSIconKind} size={11} />
        ) : (
          iconKind
        )}
        <MDSText
          variant={MDSTextVariant.TextS}
          overflow={MDSTextOverflow.Ellipsis}
          numberOfLines={1}
        >
          {label}
        </MDSText>
      </StyledSectionItemContainerLeft>
      {rightButtons && (
        <StyledSectionItemContainerRight data-right-buttons>
          {rightButtons}
        </StyledSectionItemContainerRight>
      )}
    </StyledSectionItemContainer>
  );
};
